import { Tag, Tooltip } from 'antd'
import { RollbackOutlined } from '@ant-design/icons'

/**
 * "N articoli resi" — il contrassegno che affianca lo stato di un'offerta.
 *
 * Dall'11/09/2026 un reso per acquisto errato NON cambia più lo stato
 * dell'offerta: quello che torna indietro è il bisogno, non l'ordine, e gli
 * altri articoli già consegnati non vanno rimessi in discussione. Ma un'offerta
 * "Ricevuta" con un articolo tornato al fornitore non è la stessa cosa di una
 * ricevuta e basta, e senza questo contrassegno il badge di stato racconterebbe
 * metà storia.
 *
 * Sta ACCANTO al badge, non al suo posto, perché è un'informazione
 * sull'articolo e non sull'ordine. È un componente unico, usato in ogni
 * schermata dove l'offerta compare, così il conteggio non si scrive cinque
 * volte in cinque modi leggermente diversi.
 *
 * Il conteggio arriva dal server (`articoli_resi`) e ha una regola sua, scritta
 * in backend/app/services/resi.py: un reso smette di contare quando il suo
 * sostituto è arrivato — anche se il sostituto vive in un'altra offerta.
 */
export const TagArticoliResi = ({
  quanti,
  compatto = false,
}: {
  quanti?: number | null
  compatto?: boolean
}) => {
  if (!quanti || quanti < 1) return null
  const testo = quanti === 1 ? '1 articolo reso' : `${quanti} articoli resi`
  return (
    <Tooltip title="L'ordine resta nel suo stato: è l'articolo che è tornato indietro.">
      <Tag
        color="volcano"
        icon={<RollbackOutlined />}
        style={{ margin: 0, fontSize: compatto ? 10 : 11 }}
      >
        {compatto ? `${quanti} reso${quanti === 1 ? '' : 'i'}` : testo}
      </Tag>
    </Tooltip>
  )
}

export default TagArticoliResi
